const namespaced = true;

const state = {
  items: [],
  referalCode: '',
  nameCourse: ''
};

const getters = {
  items: state => state.items,
  referalCode: state => state.referalCode,
  nameCourse: state => state.nameCourse
};

const mutations = {
  SET_ITEM: (state, payload) => {
    state.items = payload;
  },
  SET_CODE: (state, payload) => {
    state.referalCode = payload;
  },
  SET_NAME: (state, payload) => {
    state.nameCourse = payload;
  }
};

const actions = {
  async fetchList({ commit, rootGetters }, hasil) {
    try {
      let urlByRole;
      if (rootGetters['Auth/user'].cerdasTypeId === 2 || rootGetters['Auth/user'].cerdasTypeId === null) {
        urlByRole = {
          3: `/api/parent/class/${hasil.classid}/student/${hasil.id}`,
          4: `/api/class/teacher/class-list/${hasil.id}/course-list`,
          6: `/api/class/${hasil.id}/course-list/`,
          2: `/api/class/${hasil.id}/course-list/`,
          5: `/api/student/class/${hasil.id}`
        };
      } else {
        urlByRole = {
          4: `/api/teacher-lite/classroom/${hasil.id}/course-list`,
          5: `/api/student-lite/classroom/${hasil.id}/course-list`
        };
      }
      const {
        data: { data }
      } = await window.axios.get(urlByRole[rootGetters['Auth/currentRole']]);
      commit('SET_ITEM', data);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchListLiteDetail({ commit }, payload) {
    try {
      const {
        data: { data }
      } = await window.axios.get(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}
      `);
      return data;
    } catch (err) {
      throw err;
    }
  },
  // eslint-disable-next-line no-unused-vars
  uploadProfile({ commit }, payload) {
    const formData = new FormData();
    Object.keys(payload).forEach(p => formData.append(p, payload[p]));
    if (!payload.image) formData.delete('image');
    return window.axios.post(`/api/class/teacher/class/${payload.classId}/course/${payload.courseId}/upload`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
  },
  // eslint-disable-next-line no-unused-vars
  savelite({ commit }, payload) {
    return window.axios.post(`/api/teacher-lite/classroom/${payload.classroomId}/add-course`, { courseId: payload.courseId });
  },
  // eslint-disable-next-line no-unused-vars
  updatelite({ commit }, payload) {
    return window.axios.put(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}`, { status: payload.status });
  },
  // eslint-disable-next-line no-unused-vars
  destroy({ commit }, payload) {
    return window.axios.delete(`/api/teacher-lite/classroom/${payload.classroomId}/course/${payload.courseId}`);
  }
};

export default { namespaced, state, getters, mutations, actions };
